module.exports = __webpack_public_path__ + "static/media/Dip chile Serrano.b38bdfc8.jpg";